export default __webpack_public_path__ + "static/features-fixed-cbb85c861ca2fc9338c431fb69a69fab.jpg";